import { escapeAttribute, escapeJsx } from '@cli-utils/text.js'

export function fieldDescriptionLine(name: string, hint: string): string {
  if (!hint) return ''
  return `<p id="${escapeAttribute(name)}-description" className="text-sm text-muted-foreground">${escapeJsx(hint)}</p>`
}
